import { makeStyles } from "@material-ui/core";
import { theme } from "../../Theme";

export const useStyles = makeStyles({
  warningIcon: {
    width: "7rem",
    height: "7rem !important",
    position: "absolute",
    bottom: -10,
    right: 100,

    [theme.breakpoints.down("sm")]: {
      width: "3rem",
      height: "3rem !important",
    },
  },
});
